import React, { useState, useEffect } from 'react';
import SectionHeader from '../../components/SectionHeader'
import { Col, Container, Row, Form } from 'react-bootstrap'
import axios from 'axios';
import { personal, states } from '../../data';
import { loadStripe } from '@stripe/stripe-js';
import { Link } from 'react-router-dom';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const Personal = () => {
    const [proEvents, setProEvents] = useState([]);
    const [eventQuery, setEventQuery] = useState('');
    const [stateQuery, setStateQuery] = useState('');
    const [dateQuery, setDateQuery] = useState('');
    const [alcohol, setAlcohol] = useState('');
    const [maxAudience, setMaxAudience] = useState('');
    const [checked, setChecked] = useState(false);
    const handleChange = () => setChecked(!checked);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                let baseUrl = process.env.REACT_APP_BASE_URL;
                const response = await axios.get(baseUrl + '/professional-event');
                setProEvents(response.data);
            } catch (error) {
                console.error('Error fetching Events:', error);
            }
        };
        fetchEvents();
    }, []);

    const handleCheckout = async (event) => {
        const stripe = await stripePromise;
        try {
            let baseUrl = process.env.REACT_APP_BASE_URL;
            const price = alcohol === "with_out_alcohol" ? event.with_out_alcohol : event.with_alcohol;
            const convertedPrice = Math.round(price * 100);
            const response = await axios.post(baseUrl + '/create-checkout-session', {
                event_name: event.event_name,
                price: convertedPrice,
            });
            console.log('Checkout session response:', response.data);

            const { sessionId } = response.data;
            const { error } = await stripe.redirectToCheckout({ sessionId });
            if (error) {
                console.error('Stripe Checkout Error:', error);
            }
        } catch (error) {
            console.error('Error creating checkout session:', error);
        }
    };

    const filteredEvents = proEvents.filter(event => {
        return (
            event.event_name === eventQuery &&
            // event.event_name.toLowerCase().includes(eventQuery.toLowerCase()) &&
            event.state.toLowerCase().includes(stateQuery.toLowerCase()) &&
            (!maxAudience || (event.min_audience <= maxAudience && maxAudience <= event.max_audience))
        );
    });
    return (
        <>
            <section>
                <SectionHeader title="Personal Events" PageLink="Personal page"></SectionHeader>
                <div className="in-page-container pb-5">
                    <div className="about-section top__about">
                        <Container>
                            <div className="inner__form">
                                <Row>
                                    <Col md={6}>
                                        <label className="form-label" htmlFor="event">Enter or Select Event <span className='red_star'>*</span></label>
                                        <select id='event' name="event" className='form-control' value={eventQuery} onChange={(e) => setEventQuery(e.target.value)}>
                                            <option value="">Select Event</option>
                                            {personal.map((e, index) => (
                                                <option key={index} value={e.name}>{e.name}</option>
                                            ))}
                                        </select>
                                    </Col>
                                    <Col md={6} >
                                        <label className="form-label" htmlFor="state">Select State <span className='red_star'>*</span></label>
                                        <select id='state' name='state' className='form-control' value={stateQuery} onChange={(e) => setStateQuery(e.target.value)}>
                                            <option value="">Select State</option>
                                            {states.map((e, index) => (
                                                <option key={index} value={e.name}>{e.name}</option>
                                            ))}
                                        </select>
                                    </Col>
                                    <Col md={6} className='mt-4'>
                                        <label className="form-label" htmlFor="max_audience">Max Audience <span className='red_star'>*</span></label>
                                        <input type="text" id="max_audience" name='max_audience' className='form-control' value={maxAudience} onChange={(e) => setMaxAudience(parseInt(e.target.value.replace(/\D/g, "")))} />
                                    </Col>
                                    <Col md={6} className='mt-4'>
                                        <label className="form-label" htmlFor="event_date">Event Date <span className='red_star'>*</span></label>
                                        <input type="date" name='event_date' className='form-control' onChange={(e) => setDateQuery(e.target.value)} />
                                    </Col>
                                    <Col md={6} className='mt-4'>
                                        <label className="form-label" htmlFor="alcohol_rate">Alcohol <span className='red_star'>*</span></label>
                                        <select name="alcohol_rate" id="alcohol_rate" className='form-control' onChange={(e) => setAlcohol(e.target.value)}>
                                            <option value="">Select</option>
                                            <option value="with_out_alcohol">No Alcohol Served</option>
                                            <option value="with_alcohol">Alcohol Served but not for profit</option>
                                        </select>
                                    </Col>
                                    <Col md={4} className='mt-4'>
                                        <div className="phone_form">
                                            <p>Not Sure? <br /> Give us a call <br /> We'll Get You Covered Quickly!</p>
                                            <Link to="tel:(833) 320-1199">(833) 320-1199</Link>
                                        </div>
                                    </Col>
                                    <Col md={7}>
                                        <div className="events_footer_content">
                                            <h5 className='d-flex'>
                                                <Form.Check type="checkbox" id="default-checkbox" label="" checked={checked} onChange={handleChange} /> <strong>Above products have below standard Exclusions</strong>
                                            </h5>
                                            <ul>
                                                <li>Activities including water activities, amusement devices, inflatables, rides or animals no camping, sleeping overnight, no cannabis or cannabis-related products​</li>
                                                <li>Considered you have <strong>"No claims above 5k in last three years"</strong> on any event insurance</li>
                                            </ul>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="events__items">
                                <Row>
                                    {eventQuery && stateQuery && maxAudience && dateQuery && alcohol && checked ? (
                                        (() => {
                                            const filtered = filteredEvents.filter(event => {
                                                const price = alcohol === "with_out_alcohol" ? event.with_out_alcohol : event.with_alcohol;
                                                return parseFloat(price) > 0;
                                            });

                                            return filtered.length > 0 ? (
                                                filtered.map((event, index) => (
                                                    <Col md={4} key={index}>
                                                        <div className="event__card">
                                                            <div className="offer_card">
                                                                <h3>{event.event_name}</h3>
                                                                <div className="pricing">
                                                                    <span className="currency">$</span>
                                                                    <span className="price">
                                                                        {alcohol === "with_out_alcohol" ? event.with_out_alcohol : event.with_alcohol}
                                                                    </span>
                                                                </div>
                                                                <hr />
                                                                <div className="offer_description">
                                                                    <ul>
                                                                        <li>Max Audience : {event.max_audience}</li>
                                                                        <li>Each Occurrence : {event.each_occurrence}</li>
                                                                        <li>General Aggregate : {event.general_aggregate}</li>
                                                                        <li>Damage to rented Premises : {event.damage}</li>
                                                                        <li>products_comp : {event.products_comp}</li>
                                                                        <li>personal_injury : {event.personal_injury}</li>
                                                                        <li>medical_exp : {event.medical_exp}</li>
                                                                    </ul>
                                                                </div>
                                                                <button type='button' className="custom_btn_1" onClick={() => handleCheckout(event, alcohol)}>Get Policy</button>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                ))
                                            ) : (
                                                <p className='text-center mt-5'>
                                                    There is no product for this combination, this would be a custom product. Please reach us on <Link to="tel:(833) 320-1199">(833) 320-1199</Link>
                                                </p>
                                            );
                                        })()
                                    ) : null}

                                </Row>
                                {/* <Row>
                                    <Col md={8}>
                                        <div className="events_footer_content">
                                            <h5>
                                                <strong>Above products have below standard Exclusions</strong>
                                            </h5>
                                            <ul>
                                                <li>Activities including water activities, amusement devices, inflatables, rides or animals no camping, sleeping overnight, no cannabis or cannabis-related products​</li>
                                                <li>Considered you have <strong>"No claims above 5k in last three years"</strong> on any event insurance</li>
                                            </ul>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="phone_form">
                                            <p>Not Sure? <br /> Give us a call <br /> We'll Get You Covered Quickly!</p>
                                            <Link to="tel:(833) 320-1199">(833) 320-1199</Link>
                                        </div>
                                    </Col>
                                </Row> */}
                            </div>
                        </Container>
                    </div>
                </div >
            </section >
        </>
    )
}

export default Personal
